export default __webpack_public_path__ + "static/media/intlnavlogolight.a3200d73.png";